
import { PublishInterviewService } from "./publishInterviewService";
import { RejectInterviewService } from "./rejectInterviewService";
import { DepublishInterviewService } from "./depublishInterviewService";
import { PublishIntervalService } from "./publishIntervalService";

/**
 * Facade service that provides a unified interface to all publication-related services
 */
export class InterviewPublicationFacade {
  /**
   * Publish an interview
   */
  static async publishInterview(interviewId: string): Promise<boolean> {
    return PublishInterviewService.publishInterview(interviewId);
  }

  /**
   * Reject an interview
   */
  static async rejectInterview(interviewId: string): Promise<boolean> {
    return RejectInterviewService.rejectInterview(interviewId);
  }
  
  /**
   * De-publish an interview (move back to pending)
   */
  static async depublishInterview(interviewId: string): Promise<boolean> {
    return DepublishInterviewService.depublishInterview(interviewId);
  }
  
  /**
   * Get the current auto-publish interval (if set)
   */
  static async getPublishInterval(): Promise<number | null> {
    return PublishIntervalService.getPublishInterval();
  }
}
